"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.138 3a7.15 7.15 0 0 1 6.815 5.021c.084.268.063.513-.124.727a.696.696 0 0 1-1.182-.233c-.097-.267-.181-.54-.304-.796-.814-1.691-2.14-2.775-3.969-3.177-1.922-.421-3.646.054-5.114 1.363-1.017.907-1.608 2.06-1.808 3.408A5.715 5.715 0 0 0 8.51 15.61l.12.035c.356.125.55.504.44.863a.686.686 0 0 1-.832.468 6.8 6.8 0 0 1-2.456-1.219c-1.48-1.153-2.385-2.66-2.689-4.51A7.09 7.09 0 0 1 6.8 3.834a7 7 0 0 1 2.688-.795c.216-.018.433-.026.65-.039"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.383 8.708a2.12 2.12 0 0 1 2.134 2.124 2.126 2.126 0 0 1-2.108 2.136 2.126 2.126 0 0 1-2.15-2.125 2.125 2.125 0 0 1 2.124-2.135m.741 2.13a.73.73 0 0 0-.735-.736.73.73 0 0 0-.738.736.736.736 0 1 0 1.473 0m-.734 2.692c.402 0 .806-.003 1.21 0a2.13 2.13 0 0 1 2.105 1.734c.037.187.065.377.018.569a.69.69 0 0 1-.759.522.69.69 0 0 1-.61-.64 1.3 1.3 0 0 0-.04-.275.72.72 0 0 0-.682-.516q-1.241-.009-2.482 0a.73.73 0 0 0-.718.663q-.006.078-.014.155a.68.68 0 0 1-.68.614.68.68 0 0 1-.694-.6c-.031-.25.013-.495.088-.733a2.13 2.13 0 0 1 2.016-1.493c.413-.004.827 0 1.241 0m-2.561-5.393c0 .49.006.981-.001 1.472a1.673 1.673 0 0 1-1.633 1.656c-.61.006-1.22.002-1.83.005a.7.7 0 0 1-.694-.75c.029-.357.317-.626.696-.642.144-.006.29-.001.434-.002.424 0 .848-.008 1.272.004.226.006.37-.133.367-.371a232 232 0 0 1 0-2.868c0-.106.014-.218.048-.318a.686.686 0 0 1 .751-.444c.34.059.583.322.587.66.007.533.002 1.065.002 1.597z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RequestsIcon20.js.map